import { Component, h, Prop, Watch, State, Fragment } from '@stencil/core';
import { fetchPropertyData, PropertyData } from '../utility/fetch-realestate-data';

interface placeType {
  label: string;
  placeType: string;
}

interface UiCmsRealestateSurroundingPlacesBody {
  placeTypes?: placeType[];
  propertyId?: string;
  apiKey?: string;
  apiVersion?: string;
  apiUrl?: string;
}

@Component({
  tag: 'ui-cms-realestate-surrounding-places',
  styleUrl: 'ui-cms-realestate-surrounding-places.scss',
  shadow: false,
})
export class UiCmsRealestateSurroundingPlaces {
  @Prop({ mutable: true }) body: UiCmsRealestateSurroundingPlacesBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  /**
   * Indicates if data is currently being fetched
   */
  @State() fetchingData = false;

  /**
   * Property data.
   */
  @State() propertyInfo: PropertyData;

  async componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
    // fetch property data
    if (this.body.propertyId) await this.fetchingDataHandler();
  }

  /**
   * Fetches data from the API. Sets propertyInfo to the fetched data.
   */
  private async fetchingDataHandler() {
    this.fetchingData = true;
    this.propertyInfo = await fetchPropertyData({
      apiUrl: this.body.apiUrl,
      apiVersion: this.body.apiVersion,
      apiKey: this.body.apiKey,
      propertyId: this.body.propertyId,
    });
    this.fetchingData = false;
  }

  render() {
    return (
      <ui-tab-group>
        {this.body?.placeTypes?.length &&
          this.body.placeTypes.map((placeType, i) => (
            <Fragment>
              <ui-tab slot="nav" key={i} tabIndex={i} tabTitle={placeType.label} active={i === 0}></ui-tab>
              <ui-tab-panel slot="panel" active={i === 0}>
                {!this.fetchingData && this.body.propertyId ? (
                  <Fragment>
                    <ui-usercentrics-overlay pid="S1pcEj_jZX">
                      <ui-surrounding-map
                        placeType={placeType.placeType}
                        apiKey="AIzaSyCTE7NhxSs0eOGWzcDOaSHbmRmCzlFQSoE"
                        startZoomLevel={15}
                        centerLongitude={Number(this.propertyInfo.longitude)}
                        centerLatitude={Number(this.propertyInfo.latitude)}
                        mainMarkerName={this.propertyInfo.title}
                        mainMarkerAddress={this.propertyInfo.adress}
                        measurementSystem="metric"
                        transitLayer={false}
                        mapHue="0"
                      ></ui-surrounding-map>
                    </ui-usercentrics-overlay>
                    <ui-headline level={3}>{this.propertyInfo.title}</ui-headline>
                    <ui-paragraph innerHTML={this.propertyInfo.adress}></ui-paragraph>
                  </Fragment>
                ) : (
                  <sd-spinner style={{ fontSize: '2rem' }} color="primary"></sd-spinner>
                )}
              </ui-tab-panel>
            </Fragment>
          ))}
      </ui-tab-group>
    );
  }
}
